export const NEW_STREET_DEFAULT = 1
export const NEW_STREET_EMPTY = 2

export const MIN_CUSTOM_STREET_WIDTH = 10
export const MAX_CUSTOM_STREET_WIDTH = 400

export const WIDTH_ROUNDING = 0.01

export const DEFAULT_ENVIRONS = 'day'

export const STREET_WIDTH_CUSTOM = -1
export const STREET_WIDTH_SWITCH_TO_METRIC = -2
export const STREET_WIDTH_SWITCH_TO_IMPERIAL = -3

export const DEFAULT_CAPACITY_SOURCE = 'giz'
